import React from 'react'
import './Earning-Disclaimer.css'

export default function EarningDisclaimer() {
  return (
    <div className="ed-page">
      <header className="ed-header">
        <h1 className="ed-header__title">Earning Disclaimer</h1>
      </header>

      <main className="ed-content-wrap">
        <article className="ed-content">
          <p className="ed-updated">Last Updated: 2026</p>

          <p>
            Leadszora provides B2B public business data that is aggregated from
            publicly available and legitimate data sources.
          </p>
          <p>
            Any earnings, revenue figures, or business results referenced on this
            platform are illustrative only. Actual results may vary significantly
            depending on individual skillsets, market conditions, industry type,
            and how the data is used.
          </p>
          <p>
            Users are solely responsible for ensuring that any marketing, outreach,
            or communication conducted using Leadszora data complies with all
            applicable laws and regulations, digital marketing laws.
          </p>
          <p>
            Leadszora does not make any guarantees regarding business success,
            conversion outcomes, income generation, or profitability. Your results
            will depend entirely on your own actions, strategies, and execution.
          </p>
          <p>
            By using this platform, you acknowledge and agree that Leadszora
            shall not be held liable for any losses, damages, or legal issues
            arising from the use or misuse of the data provided.
          </p>
          <p>
            Some users may promote Leadszora as affiliates. Any commissions earned
            are based on individual effort and marketing skills. Leadszora does not
            guarantee affiliate income or results.
          </p>
          <p>
            This platform does not provide legal, financial, or professional advice.
            Users should consult qualified professionals before making business
            decisions.
          </p>
        </article>
      </main>

      <footer className="ed-footer">
        <div className="ed-footer__inner">
          <span>Copyright &copy; Leadszora 2026</span>
          <nav aria-label="Legal links">
            <a href="/">Home</a>
            <span>|</span>
            <a href="/2.0privacy-policy">Privacy Policy</a>
            <span>|</span>
            <a href="/2.0Terms-of-Service">Terms &amp; Conditions</a>
            <span>|</span>
            <a href="/2.0Earning-Disclaimer">Earning Disclaimer</a>
            <span>|</span>
            <a href="/2.0Contact-Us">Contact Us</a>
          </nav>
        </div>
      </footer>
    </div>
  )
}
